import { keymap, type EditorView } from "@codemirror/view";
import { getMagicSyntaxSelectionSignature } from "./plugin";
import { magicScanField } from "./scan-state";

export function exitActiveMagicSyntaxEdit(view: EditorView): boolean {
    const analysis = view.state.field(magicScanField, false);
    if (!analysis) return false;

    const selectionSignature = getMagicSyntaxSelectionSignature(
        view,
        analysis.scan,
    );
    if (!selectionSignature) return false;

    view.contentDOM.blur();
    return true;
}

export const magicSyntaxKeymap = keymap.of([
    {
        key: "Escape",
        run: exitActiveMagicSyntaxEdit,
    },
]);
